import { ReactElement } from 'react';
import useAppFocus from '../../../hooks/global/useAppFocus';

interface Props {
  children: any;
}

export default function AppFocusObserver(props: Props): ReactElement {
  const { children } = props;

  useAppFocus();

  return children;
}
